import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import "./premiumproduct.css";

const ApplePremiumSection = () => {
  return (
    <div>
        <motion.div
          className="section-header-product text-center my-5"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="main-title">Explore Our Premium Collection</h2>
          <p className="sub-title">
            Innovation. Performance. Elegance. Designed for the future.
          </p>
        </motion.div>
      <section className="apple-wrapper text-dark">
        <Container fluid>
          <Row className="g-4">
            {/* LEFT GRID */}
            <Col lg={5} className="left-grid text-center">
              <Row className="g-4">
                {/* Card 1 */}
                <Col md={6} sm={6} xs={12}>
                  <motion.div
                    className="product-card-section purple"
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7 }}
                    viewport={{ once: true }}
                  >
                    <img src="./images/iphone.png" alt="" />
                    <div className="text">
                      <h5>iPhone 17 </h5>
                      {/* <p>Even more durable.</p> */}
                    </div>
                  </motion.div>
                </Col>

                {/* Card 2 */}
                <Col md={6} sm={6} xs={12}>
                  <motion.div
                    className="product-card-section dark"
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.2 }}
                    viewport={{ once: true }}
                  >
                    <img src="./images/ipad.webp" alt="" />
                    <div className="text">
                      <h5>iPad Pro</h5>
                      {/* <p>All out Pro.</p> */}
                    </div>
                  </motion.div>
                </Col>

                {/* Card 3 */}
                <Col md={6} sm={6} xs={12}>
                  <motion.div
                    className="product-card-section blue"
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.3 }}
                    viewport={{ once: true }}
                  >
                    <img src="./images/watch.png" alt="" />
                    <div className="text">
                      <h5>Watch Series 11</h5>
                      {/* <p>Superfast. Supersmart.</p> */}
                    </div>
                  </motion.div>
                </Col>

                {/* Card 4 */}
                <Col md={6} sm={6} xs={12}>
                  <motion.div
                    className="product-card-section pink"
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.4 }}
                    viewport={{ once: true }}
                  >
                    <img src="./images/macbook.webp" alt="" />
                    <div className="text">
                      <h5>Mackbook Pro</h5>
                      {/* <p>Ultimate watch for a healthy life.</p> */}
                    </div>
                  </motion.div>
                </Col>
              </Row>
            </Col>

            {/* RIGHT HERO */}
            <Col lg={7}>
              <motion.div
                className="hero-box"
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <div className="hero-content">
                  <h2> iPhone Air</h2>
                  <h4>The thinnest iPhone ever.</h4>
                  <p>With the power of pro inside.</p>

                  <Button className="explore-btn">Explore</Button>
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default ApplePremiumSection;
